import styled from 'styled-components';

export const NoResultsContainer = styled.div`
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const AdditionalInfo = styled.div`
  text-align: right;
  a {
    color: ${p => p.theme.brandPrimary};
  }
`;
